import React from "react";

// Repeating SVG honeycomb pattern used as fixed side decorations.
const HEX_SVG = encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'>
    <g fill='none' stroke='rgba(255,255,255,0.55)' stroke-width='1.4'>
      <polygon points='60,4 112,32 112,88 60,116 8,88 8,32' />
      <polygon points='30,-56 82,-28 82,28 30,56 -22,28 -22,-28' />
      <polygon points='90,64 142,92 142,148 90,176 38,148 38,92' />
    </g>
  </svg>`
);

export default function HexBackground() {
  const bg = `url("data:image/svg+xml;utf8,${HEX_SVG}")`;
  return (
    <>
      <div className="hex-side left" style={{ backgroundImage: bg }} aria-hidden />
      <div className="hex-side right" style={{ backgroundImage: bg }} aria-hidden />
    </>
  );
}

